import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'brand_tile-click_brand_tile_image_scroll-click';
/**
 * This event tracks when users interact with the brand tile image scrolling.
 */ export function trackBrandTileClickBrandTileImageScrollClick(brandToken, Index, Action2) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            brandToken: brandToken,
            Index: Index,
            Action2: Action2
        }
    });
}
